module.exports = __webpack_public_path__ + "static/media/objects2_18.ef2cfb4b.svg";